import React, { useCallback, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Modal from 'utils/packages/Modal';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconPaperDownload, IconPaperDownloadStar } from 'design-system/icons';
import { LiveExportStatus } from 'features/export-data-live/LiveExportStatus';
import { useLiveSheetUpdatedAtIntervalInitWithCache } from 'features/export-data-live/useLiveSheet';
import { useMainStackNavigation, } from 'utils/types/navigationV6';
import { CardView } from 'design-system';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { isWeb } from '../../constants';
const strings = {
    modalTitle: 'Choose your export method',
    liveExportTitle: 'Live export',
    liveExportDescription: 'Automatically export new transactions to Google Sheets',
    manualExportTitle: 'Manual export',
    manualExportDescription: 'Select and export data whenever you need',
};
const ExportDataMethodModal = ({ exportDataParams }) => {
    const navigation = useMainStackNavigation();
    const styles = useStyles(styleSet);
    const [liveSheetStatus, wasCached] = useLiveSheetUpdatedAtIntervalInitWithCache();
    const goToLiveExport = useCallback(() => {
        if (liveSheetStatus && !wasCached && liveSheetStatus.isEnabled) {
            navigation.navigate('ExportDataLive');
        }
        else {
            navigation.navigate('ExportDataLiveTransit', { manageIfEnabled: true });
        }
    }, [liveSheetStatus, wasCached]);
    const indicator = useMemo(() => {
        if (liveSheetStatus && liveSheetStatus.isEnabled) {
            const { issue, spreadsheetId, needAuthenticate } = liveSheetStatus;
            return (<LiveExportStatus active={!issue} syncInProgress={!issue && !needAuthenticate && !spreadsheetId}/>);
        }
        return null;
    }, [liveSheetStatus]);
    const LiveExportItem = useMemo(() => (<SettingsItem title={strings.liveExportTitle} description={strings.liveExportDescription} onPress={() => Modal.hide(goToLiveExport)} icon={<IconPaperDownloadStar gradientKey="darkPink"/>} topDescription={indicator}/>), [goToLiveExport, indicator]);
    const ManualExportItem = useMemo(() => (<SettingsItem title={strings.manualExportTitle} description={strings.manualExportDescription} onPress={() => {
            Modal.hide(() => {
                navigation.navigateDeprecated('ExportData', exportDataParams);
            });
        }} icon={<IconPaperDownload gradientKey="skyBlue"/>}/>), [exportDataParams]);
    const Content = (<View>
      {LiveExportItem}
      {ManualExportItem}
    </View>);
    if (isWeb) {
        return (<CardView webPadding noMarginBottom style={styles.cardViewContainer}>
        {Content}
      </CardView>);
    }
    return Content;
};
export function showExportDataMethodModal(props = { exportDataParams: undefined }) {
    Modal.show(<ExportDataMethodModal {...props}/>, {
        lightBg: true,
        title: strings.modalTitle,
        containerStyle: staticStyles.containerStyle,
    });
}
const staticStyles = StyleSheet.create({
    containerStyle: {
        paddingHorizontal: 0,
    },
});
const styleSet = createStyleSheets((colors) => ({
    cardViewContainer: {
        backgroundColor: colors.background.light,
    },
}));
